import { mixpanel } from '@fiverr-private/obs';
import { getDataFromStores } from '../../../utils';
import { MIXPANEL_EVENT_PROPERTIES } from '../../constants';
import { Enrichment } from '../types';
import type { FAQClickedInput, FAQClickedStore } from './types';
/**
 * The user clicked on one of FAQs
 */
export const createReportFAQClicked =
    (store: FAQClickedStore, enrichment?: Enrichment) =>
    ({ question }: FAQClickedInput): void => {
        const payload = {
            ...getDataFromStores(store.user, store.referrer, store.fromBoost, store.pageType, store.pagePath),
            [MIXPANEL_EVENT_PROPERTIES.QUESTION_CLICKED]: question,
            ...enrichment,
        };

        mixpanel.track('Logo Maker - Landing Page - FAQ clicked', payload);
    };
